// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NiH9mJY3iVeTAl {
  display: flex;
  flex-shrink: 0;
  align-items: center;
}
.NiH9mJY3iVeTAl.dfzJI_PuP5CEVA {
  margin: var(--ds-space-0, 0) var(--ds-space-050, 4px);
}
.bx61s1kHS9X4pV {
  min-width: 32px;
  min-height: 32px;
  margin: var(--ds-space-0, 0);
  padding: var(--ds-space-075, 6px);
  transition-duration: unset;
}
.bx61s1kHS9X4pV.dfzJI_PuP5CEVA {
  padding-right: var(--ds-space-050, 4px);
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.bx61s1kHS9X4pV.dfzJI_PuP5CEVA.XS2jDSQUvbhiwk {
  padding: var(--ds-space-075, 6px) var(--ds-space-0, 0) var(--ds-space-075, 6px) var(--ds-space-075, 6px);
}
@container boardHeader (width < 800px) {
  .bx61s1kHS9X4pV {
    padding: var(--ds-space-075, 6px);
  }
  .bx61s1kHS9X4pV .zYtAt6pns4cM3s {
    margin-right: var(--ds-space-0, 0);
  }
  .bx61s1kHS9X4pV .PqTwU_wwUxQy6s {
    display: none;
  }
}
@keyframes R3FymDnMx4Bpcq {
  0% {
    opacity: 20%;
  }
  50% {
    opacity: 80%;
  }
  100% {
    opacity: 20%;
  }
}
.Ddmd9Odbwri9dF {
  display: block;
  margin-left: 8px;
  padding-right: 6px;
  padding-left: var(--ds-space-050, 4px);
  border-radius: 20px;
  background-color: var(--dynamic-button-highlighted-hovered, var(--ds-surface, #ffffff));
  color: var(--dynamic-button-highlighted-text, var(--ds-text, #172b4d));
}
.Ddmd9Odbwri9dF.xamRtL52GXax7W {
  animation-name: R3FymDnMx4Bpcq;
  animation-duration: 1.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  color: transparent;
  -webkit-user-select: none;
          user-select: none;
}
.Ddmd9Odbwri9dF.XS2jDSQUvbhiwk {
  margin-right: var(--ds-space-0, 0px);
}
.Ddmd9Odbwri9dF::before {
  content: '';
  display: inline-flex;
  position: relative;
  top: 1px;
  width: 12px;
  height: 12px;
  margin-right: var(--ds-space-075, 6px);
  border-radius: var(--ds-border-radius-circle, 50%);
  background-color: var(--ds-icon-brand, #0c66e4);
}
.body-light-board-background .Ddmd9Odbwri9dF::before {
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  background-color: #579dff;
}
.body-dark-board-background .Ddmd9Odbwri9dF::before {
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  background-color: #0c66e4;
}
.rRs_e7MShvOFXM {
  min-width: 32px;
  min-height: 32px;
  margin: var(--ds-space-0, 0);
  padding: var(--ds-space-075, 6px) var(--ds-space-100, 8px);
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.rRs_e7MShvOFXM .zYtAt6pns4cM3s {
  display: none;
  margin-right: var(--ds-space-0, 0);
}
@container boardHeader (width < 800px) {
  .rRs_e7MShvOFXM {
    padding: var(--ds-space-075, 6px);
  }
  .rRs_e7MShvOFXM .PqTwU_wwUxQy6s {
    display: none;
    padding-right: var(--ds-space-075, 6px);
  }
  .rRs_e7MShvOFXM .zYtAt6pns4cM3s {
    display: block;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"buttonGroup": `NiH9mJY3iVeTAl`,
	"isFiltering": `dfzJI_PuP5CEVA`,
	"filterButton": `bx61s1kHS9X4pV`,
	"isCollapsed": `XS2jDSQUvbhiwk`,
	"buttonIcon": `zYtAt6pns4cM3s`,
	"buttonText": `PqTwU_wwUxQy6s`,
	"filtersCount": `Ddmd9Odbwri9dF`,
	"isLoadingCards": `xamRtL52GXax7W`,
	"fadeFiltersCount": `R3FymDnMx4Bpcq`,
	"clearFiltersButton": `rRs_e7MShvOFXM`
};
export default ___CSS_LOADER_EXPORT___;
